export const KeyIcon = ({ theme }: { theme: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.1646 12.5C9.30006 13.9945 7.6842 15 5.8335 15C3.07207 15 0.833496 12.7614 0.833496 10C0.833496 7.23858 3.07207 5 5.8335 5C7.6842 5 9.30006 6.0055 10.1646 7.5H16.3217C16.5427 7.5 16.7546 7.5878 16.9109 7.74408L18.9942 9.82741C19.3197 10.1528 19.3197 10.6805 18.9942 11.0059L16.4228 13.5774C16.0973 13.9028 15.5697 13.9028 15.2442 13.5774L14.1668 12.5L13.0894 13.5774C12.764 13.9028 12.2363 13.9028 11.9109 13.5774L10.8335 12.5H10.1646ZM7.50016 10C7.50016 10.9205 6.75397 11.6667 5.8335 11.6667C4.91302 11.6667 4.16683 10.9205 4.16683 10C4.16683 9.07953 4.91302 8.33333 5.8335 8.33333C6.75397 8.33333 7.50016 9.07953 7.50016 10ZM10.4168 9.16667C10.1867 9.16667 10.0002 9.35321 10.0002 9.58333V10C10.0002 10.2301 10.1867 10.4167 10.4168 10.4167H16.0418C16.387 10.4167 16.6668 10.1368 16.6668 9.79167C16.6668 9.44649 16.387 9.16667 16.0418 9.16667H10.4168Z"
        fill={theme === 'light' ? '#343434' : '#FFFFFF'}
      />
    </svg>
  );
};
